// extracted by mini-css-extract-plugin
export default {"app-container-loader":"src_app-container-loader__D5Zfq"};